// extracted by mini-css-extract-plugin
module.exports = {"about-header":"index__about-header__1gjlI","informationTitle":"index__informationTitle__eh9TC","productName":"index__productName__jiL6u"};